module.exports = __webpack_public_path__ + "img/img_31.f6c81104.png";